import React from 'react';
import { Globe, Save, X } from 'lucide-react';
import './SaveMatch.css';

function SaveMatch({ onMatchSaved, editingMatch, nightMode, isSaving, onCancelEdit, isPublic, setIsPublic }) {
  return (
    <div className={`save-match ${nightMode ? 'night-mode' : ''}`}>
      <label className="public-checkbox">
        <input
          type="checkbox"
          checked={isPublic}
          onChange={(e) => setIsPublic(e.target.checked)}
          disabled={isSaving}
        />
        <Globe size={16} />
        <span className="checkbox-label">Public</span>
      </label>
      <div className="save-match-buttons">
        <button 
          className="save-button" 
          onClick={onMatchSaved}
          disabled={isSaving}
        >
          <Save size={16} />
          {isSaving ? 'Saving…' : (editingMatch ? 'Update match' : 'Save match')}
        </button>
        {editingMatch && onCancelEdit && (
          <button 
            className="cancel-button" 
            onClick={onCancelEdit}
            disabled={isSaving}
          >
            <X size={16} />
            Cancel edit
          </button>
        )}
      </div>
    </div>
  );
}

export default SaveMatch;
